import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  subtext?: string;
  className?: string;
  fullWidth?: boolean;
  size?: 'md' | 'lg';
};
const sizes = {
  md: 'px-5 py-3 text-sm',
  lg: 'px-6 py-4 text-sm md:px-10 md:py-5 md:text-lg'
};
export function Button({
  children,
  href,
  subtext,
  className = '',
  fullWidth,
  size = 'md'
}: ButtonProps) {
  const external = !href.startsWith('#');
  return <motion.a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.12,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex flex-col items-center justify-center rounded-xl border-2 border-b-[6px] border-berry-800 bg-berry-600 text-center font-display font-black uppercase tracking-wide text-white shadow-xl shadow-berry-800/25 transition-colors duration-150 ease-out hover:bg-berry-700 focus:outline-none focus:ring-4 focus:ring-blush-400/70 ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-264" data-mp="1sizticizjs81">
      <span className="flex items-center gap-2" data-id="element-265" data-mp="erh4t8yt21er">
        {children}
        <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-266" data-mp="tnyfdxz67c09" />
      </span>
      {subtext && <span className="mt-1 font-sans text-[11px] font-semibold normal-case tracking-normal text-white/90 md:text-xs" data-id="element-267" data-mp="on10pvddd03i">
          {subtext}
        </span>}
    </motion.a>;
}